import { Toastr } from '../../components/Toastr';

export const successHandler = response => {
    if (response) {
        if (response.status === 200) {
            Toastr.success('Operation success.');
        }
    }
};

export const searchHandler = response => {
    if (response) {
        if (response.data.length === 0) {
            Toastr.info('No results found.');
        }
    }
};



// WEBPACK FOOTER //
// ./src/services/helper/success-helper.js